import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Typo from 'components/ui/Typo';
import { accessibilityParamsStore } from 'stores/root';

import s from './Copyright.module.scss';

type CopyrightProps = {
  className?: string;
};

const Copyright: React.FC<CopyrightProps> = ({ className }) => {
  const currentYear = new Date().getFullYear();
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;

  return (
    <div className={cn(s.root, className)}>
      <Typo
        className={cn(s.root__text, isAccessibilityMode && s.root__text_accessibility)}
        element="span"
        weight="bold"
        view="body-3"
      >
        &copy;&nbsp;{currentYear} «Россия — страна возможностей». Все права защищены
      </Typo>
    </div>
  );
};

export default observer(Copyright);
